import { documentEnumeration } from "@/api/order";
import { arrayToObject } from "@/utils/tool";

const orderSelect = {
    state: {
        orderTypeList: [],
        orderDeliveryRateList: [],
        customerOrderTypeList: [],
        currencyList: [],
        warehouseList: [],
        paymentList: [],
        departmentList:[],
        transport_typeList:[],
        delivery_typeList:[],
        payment_typeList:[],
        shipment_portList:[],
        companyList:[],
        reason_closureList:[],
        reasons_returnList:[],
        languageList:[],
        countryList:[],
        ordersConfig:{},
        overdue_statusList:[
          {
            label: "未逾期",
            value: 1
          },
          {
            label: "已逾期",
            value: 2
          }
        ]
    },
    mutations: {
      set_orderTypeList: (state, val) => {
        state.orderTypeList = val

        // 配置购物车的订单操作
        const objDataArr = val;
        let ordersConfigs=[]
        // console.log(777,objData)
        objDataArr.forEach((item,index)=>{
          let tempObj1={
              func: "add",
              commandType: index,
              order_type_id:item.value,
              txt:`新${item.label}`,
          }
          let tempObj2={
              title: `选择${item.label}`,
              dialogJoinTo: `加入${item.label}`,
              func: "list",
              commandType: index,
              order_type_id:item.value,
              txt:`加入${item.label}`,
          }
          ordersConfigs.push(tempObj1)
          ordersConfigs.push(tempObj2)
        })
        const obj1={
            func: "add",
            commandType: "a",
            order_type_id:'',
            txt:'新报价单',
        }
        const obj2={
            title: "选择报价单",
            dialogJoinTo: "加入报价单",
            func: "list",
            commandType: "b",
            order_type_id:'',
            txt:'加入已有报价单',
        }
        ordersConfigs.unshift(obj2)
        ordersConfigs.unshift(obj1)
        const objData = arrayToObject(ordersConfigs);
        for (let key in objData) {
          objData[key].commandType = key
        }
        state.ordersConfig = objData;
        // console.log(888,state.ordersConfig)
      },
      set_orderDeliveryRateList: (state, val) => {
        state.orderDeliveryRateList = val
      },
      set_customerOrderTypeList: (state, val) => {
        state.customerOrderTypeList = val
      },
      set_currencyList: (state, val) => {
        state.currencyList = val
      },
      set_warehouseList: (state, val) => {
        state.warehouseList = val
      },
      set_paymentList: (state, val) => {
        state.paymentList = val
      },
      set_departmentList: (state, val) => {
        state.departmentList = val
      },
      set_transport_typeList: (state, val) => {
        state.transport_typeList = val
      },
      set_delivery_typeList: (state, val) => {
        state.delivery_typeList = val
      },
      set_payment_typeList: (state, val) => {
        state.payment_typeList = val
      },
      set_shipment_portList: (state, val) => {
        state.shipment_portList = val
      },
      set_companyList: (state, val) => {
        state.companyList = val
      },
      set_reason_closureList: (state, val) => {
        state.reason_closureList = val
      },
      set_reasons_returnList: (state, val) => {
        state.reasons_returnList = val
      },
      set_languageList: (state, val) => {
        state.languageList = val
      },
      set_countryList: (state, val) => {
        state.countryList = val
      },
    },
    getters: {},
    actions: {
        // 获取下拉框数据
        async getDocumentEnumeration({ commit }){
          let res = await documentEnumeration()
          // console.log(900000,res.data)
          if (res.data.status==200) {
            var transport_typeList = res.data.data.transport_type||[]
            var transport_typeLists = []
            if (transport_typeList&&transport_typeList.length>0) {
              for (var i = 0; i < transport_typeList.length; i++) {
                transport_typeLists.push({label: transport_typeList[i].enum_val, value: transport_typeList[i].enums_id});
              }
            }
            commit('set_transport_typeList', transport_typeLists)
            var delivery_typeList = res.data.data.delivery_type||[]
            var delivery_typeLists = []
            if (delivery_typeList&&delivery_typeList.length>0) {
              for (var i = 0; i < delivery_typeList.length; i++) {
                delivery_typeLists.push({label: delivery_typeList[i].enum_val, value: delivery_typeList[i].enums_id});
              }
            }
            // set_delivery_typeList(delivery_typeLists)
            commit('set_delivery_typeList', delivery_typeLists)
            var payment_typeList = res.data.data.payment_method||[]
            var payment_typeLists = []
            if (payment_typeList&&payment_typeList.length>0) {
              for (var i = 0; i < payment_typeList.length; i++) {
                payment_typeLists.push({label: payment_typeList[i].enum_val, value: payment_typeList[i].enums_id});
              }
            }
            commit('set_payment_typeList', payment_typeLists)
            var shipment_portList = res.data.data.shipment_port||[]
            var shipment_portLists = []
            if (shipment_portList&&shipment_portList.length>0) {
              for (var i = 0; i < shipment_portList.length; i++) {
                shipment_portLists.push({label: shipment_portList[i].enum_val, value: shipment_portList[i].enums_id});
              }
            }
            commit('set_shipment_portList', shipment_portLists)
            var departmentList = res.data.data.department||[]
            var departmentLists = []
            if (departmentList&&departmentList.length>0) {
              for (var i = 0; i < departmentList.length; i++) {
                departmentLists.push({label: departmentList[i].department_name, value: departmentList[i].department_id});
              }
            }
            commit('set_departmentList', departmentLists)
            var orderTypeList = res.data.data.orders_type||[]
            var orderTypeLists = []
            if (orderTypeList&&orderTypeList.length>0) {
              for (var i = 0; i < orderTypeList.length; i++) {
                orderTypeLists.push({label: orderTypeList[i].type_name, value: orderTypeList[i].orders_type_id});
              }
            }
            commit('set_orderTypeList', orderTypeLists)
            //订单交付比率
            var orderDeliveryRateList = res.data.data.order_delivery_rate||[]
            var orderDeliveryRateLists = []
            if (orderDeliveryRateList&&orderDeliveryRateList.length>0) {
              for (var i = 0; i < orderDeliveryRateList.length; i++) {
                orderDeliveryRateLists.push({label: orderDeliveryRateList[i].enum_val, value: orderDeliveryRateList[i].enums_id});
              }
            }
            commit('set_orderDeliveryRateList', orderDeliveryRateLists)
            //客户订单类型
            var customerOrderTypeList = res.data.data.customer_order_type||[]
            var customerOrderTypeLists = []
            if (customerOrderTypeList&&customerOrderTypeList.length>0) {
              for (var i = 0; i < customerOrderTypeList.length; i++) {
                customerOrderTypeLists.push({label: customerOrderTypeList[i].enum_val, value: customerOrderTypeList[i].enums_id});
              }
            }
            commit('set_customerOrderTypeList', customerOrderTypeLists)

            var currencyList = res.data.data.currency||[]
            var currencyLists = []
            if (currencyList&&currencyList.length>0) {
              for (var i = 0; i < currencyList.length; i++) {
                currencyLists.push({label: currencyList[i].currency_name, value: currencyList[i].currency_id});
              }
            }
            commit('set_currencyList', currencyLists)
            var languageList = res.data.data.language||[]
            var languageLists = []
            if (languageList&&languageList.length>0) {
              for (var i = 0; i < languageList.length; i++) {
                languageLists.push({label: languageList[i].language_types, value: languageList[i].language_id});
              }
            }
            commit('set_languageList', languageLists)
            var companyList = res.data.data.company||[]
            var companyLists = []
            if (companyList&&companyList.length>0) {
              for (var i = 0; i < companyList.length; i++) {
                companyLists.push({label: companyList[i].company_name, value: companyList[i].company_id});
              }
            }
            commit('set_companyList', companyLists)
            var reason_closureList = res.data.data.reason_closure||[]
            var reason_closureLists = []
            if (reason_closureList&&reason_closureList.length>0) {
              for (var i = 0; i < reason_closureList.length; i++) {
                reason_closureLists.push({label: reason_closureList[i].enum_val, value: reason_closureList[i].enums_id});
              }
            }
            commit('set_reason_closureList', reason_closureLists)
            var reasons_returnList = res.data.data.reasons_return||[]
            var reasons_returnLists = []
            if (reasons_returnList&&reasons_returnList.length>0) {
              for (var i = 0; i < reasons_returnList.length; i++) {
                reasons_returnLists.push({label: reasons_returnList[i].enum_val, value: reasons_returnList[i].enums_id});
              }
            }
            commit('set_reasons_returnList', reasons_returnLists)
            var warehouseList = res.data.data.warehouse||[]
            var warehouseLists = []
            if (warehouseList&&warehouseList.length>0) {
              for (var i = 0; i < warehouseList.length; i++) {
                warehouseLists.push({label: warehouseList[i].warehouse_name, value: warehouseList[i].warehouse_no,company_id: warehouseList[i].company_id});
              }
            }
            commit('set_warehouseList', warehouseLists)

            var countryList = res.data.data.country||[]
            var countryLists = []
            if (countryList&&countryList.length>0) {
              for (var i = 0; i < countryList.length; i++) {
                countryLists.push({label: countryList[i].country_name, value: countryList[i].code});
              }
            }
            commit('set_countryList', countryLists)
          }
        }

    }
}

export default orderSelect



// WEBPACK FOOTER //
// ./src/store/modules/orderSelect.js